__turbopack_context__.v({
  "desktop": "BundleProductCard-module-scss-module__xITdiW__desktop",
  "mobile": "BundleProductCard-module-scss-module__xITdiW__mobile",
});
